import type React from "react";
import { useState } from "react";

import { NavbarContext } from "./useNavbarContext";

type NavbarContextProviderProps = {
  children?: React.ReactNode;
};

export const NavbarContextProvider: React.FC<NavbarContextProviderProps> = ({
  children,
}) => {
  const [customTitle, setCustomTitle] = useState<string>();

  return (
    <NavbarContext.Provider
      value={{
        customTitle,
        setCustomTitle: setCustomTitle,
      }}
    >
      {children}
    </NavbarContext.Provider>
  );
};
